import {Limit, LimitCreate, UpdateLimitsRequest} from "./@types/Limit";


export class LimitRepository {
    private httpService: IHttpService;
    private baseUrl: string;

    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/limits';
    }
    async getAll(filters?: Record<string, any>): Promise<Limit[]>{
        const response = await this.httpService.get<TKResponse<Limit[]>>(this.baseUrl, { params: filters });
        return response.data.sort((a, b) => ((a as any).name ?? '').localeCompare((b as any).name ?? ''));
    }
    async getOne(id: number): Promise<Limit> {
        const response = await this.httpService.get<TKResponse<Limit>>(`${this.baseUrl}/${id}`);
        return response.data;
    }
    async create(data: LimitCreate): Promise<Limit> {
        const response = await this.httpService.post<TKResponse<Limit>, LimitCreate>(this.baseUrl, { data });
        return response.data;
    }
    async update(id: number, data: UpdateLimitsRequest): Promise<Limit> {
        const response = await this.httpService.patch<TKResponse<Limit>, UpdateLimitsRequest>(`${this.baseUrl}/${id}`, { data });
        return response.data;
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}

